import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useMemo, useState } from 'react';
import { useAuth } from '@restworld/feature-authentication';
import { useNavigationItemsByUserType, useAvatarImage, useNavigationContext } from '@restworld/utils-common';
import { MobileOverlayNav, NavigationBar, FrontViewImpressionTextSearchbox, NavbarHomeTitleContent, HomePageNavbarTitleContent, LocaleSelector } from '../../';
import { DesktopOverlayNav } from '../navigation-bar/navigation-bar.components/desktop-overlay-nav';
import BaseNavUI from '../navigation-bar/navigation-bar.components/base-nav-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var DefaultNavigationBar = function DefaultNavigationBar(_ref) {
  var authProps = _ref.authProps,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      algoliaSearchBarElement = _ref.algoliaSearchBarElement,
      _ref$hasBorderBottom = _ref.hasBorderBottom,
      hasBorderBottom = _ref$hasBorderBottom === void 0 ? true : _ref$hasBorderBottom,
      testId = _ref.testId,
      hideNavElement = _ref.hideNavElement;

  var _useState = useState(false),
      isNavOverlay = _useState[0],
      navOverlayToggler = _useState[1];

  var _useAuth = useAuth(),
      isAuthenticated = _useAuth.isAuthenticated,
      user = _useAuth.user;

  var avatarProps = useAvatarImage();
  var items = useNavigationItemsByUserType(user === null || user === void 0 ? void 0 : user.type, isAuthenticated);
  var defaultMobileAttributes = useMemo(function () {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      isAuthenticated: isAuthenticated
    }, avatarProps), {
      isNavOverlay: isNavOverlay,
      navOverlayToggler: navOverlayToggler
    }), items), authProps);
  }, [isAuthenticated, avatarProps, isNavOverlay, items, authProps]);

  var _useNavigationContext = useNavigationContext(),
      router = _useNavigationContext.router;

  var locale = router.locale;
  var basePath = router.asPath;
  var mobileVersionNav = useMemo(function () {
    var background = variant === 'home-page' || variant === 'home-page--with-explorer' ? 'purple-gradient' : 'white';

    var localeComponent = /*#__PURE__*/_jsx(LocaleSelector, {
      onChange: function onChange(locale) {
        return router.push(basePath, basePath, {
          locale: locale
        });
      },
      value: locale,
      background: background
    });

    if (variant === 'home-page' || variant === 'home-page--with-explorer') return /*#__PURE__*/_jsxs(_StyledDiv, {
      children: [/*#__PURE__*/_jsx(NavigationBar, {
        twStyle: {
          "@media (min-width: 1024px)": {
            "display": "none"
          }
        },
        justify: "between",
        hasBorderedBottom: false,
        hasRoundedBottom: false,
        background: "home-mobile-nav",
        position: "fixed",
        testId: testId,
        navElement: /*#__PURE__*/_jsx(MobileOverlayNav, _objectSpread(_objectSpread({}, defaultMobileAttributes), {}, {
          background: background,
          localeComponent: localeComponent,
          testId: "mobile-".concat(testId, "-overlay"),
          hideNavElement: hideNavElement
        }))
      }), /*#__PURE__*/_jsx(FrontViewImpressionWrapper, {
        isNavOverlay: isNavOverlay,
        children: /*#__PURE__*/_jsx(FrontViewImpressionTextSearchbox, {
          algoliaSearchBarElement: algoliaSearchBarElement,
          children: variant === 'home-page' ? /*#__PURE__*/_jsx(NavbarHomeTitleContent, {}) : /*#__PURE__*/_jsx(HomePageNavbarTitleContent, {})
        })
      })]
    });
    return /*#__PURE__*/_jsx(NavigationBar, {
      twStyle: {
        "@media (min-width: 1024px)": {
          "display": "none"
        }
      },
      justify: "between",
      background: background,
      testId: testId,
      navElement: /*#__PURE__*/_jsx(MobileOverlayNav, _objectSpread(_objectSpread({}, defaultMobileAttributes), {}, {
        background: background,
        localeComponent: localeComponent,
        testId: "mobile-".concat(testId, "-overlay"),
        hideNavElement: hideNavElement,
        children: algoliaSearchBarElement
      })),
      hasBorderedBottom: hasBorderBottom
    });
  }, [variant, locale, testId, defaultMobileAttributes, isNavOverlay, algoliaSearchBarElement, hideNavElement, hasBorderBottom, router, basePath]);
  var desktopMenuItems = useMemo(function () {
    var background = 'white';

    var localeComponent = /*#__PURE__*/_jsx(LocaleSelector, {
      onChange: function onChange(locale) {
        return router.push(basePath, basePath, {
          locale: locale
        });
      },
      value: locale,
      background: background
    });

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(_StyledDiv2, {
        children: algoliaSearchBarElement
      }), /*#__PURE__*/_jsx(_StyledDiv3, {
        children: /*#__PURE__*/_jsx(DesktopOverlayNav, _objectSpread(_objectSpread({}, defaultMobileAttributes), {}, {
          localeComponent: localeComponent,
          testId: "desktop-".concat(testId, "-overlay")
        }))
      })]
    });
  }, [algoliaSearchBarElement, basePath, defaultMobileAttributes, locale, router, testId]); // --- //

  var desktopVersionNav = useMemo(function () {
    return /*#__PURE__*/_jsx(NavigationBar, {
      navElement: /*#__PURE__*/_jsx(BaseNavUI, {
        children: hideNavElement ? null : desktopMenuItems
      }),
      justify: "between",
      twStyle: {
        "display": "none",
        "@media (min-width: 1024px)": {
          "display": "block"
        }
      },
      testId: testId
    });
  }, [desktopMenuItems, hideNavElement, testId]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [mobileVersionNav, desktopVersionNav]
  });
};
export var FrontViewImpressionWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "default-navigation-bar__FrontViewImpressionWrapper",
  componentId: "sc-b7kgid-0"
})(["", " ", ""], {
  "boxSizing": "border-box",
  "width": "100%",
  "paddingTop": "88px",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
}, function (_ref2) {
  var isNavOverlay = _ref2.isNavOverlay;
  return isNavOverlay ? {
    "paddingTop": "88px",
    "@media (min-width: 768px)": {
      "paddingTop": "131px"
    }
  } : {};
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "default-navigation-bar___StyledDiv",
  componentId: "sc-b7kgid-1"
})({
  "position": "relative",
  "boxSizing": "border-box",
  "display": "flex",
  "width": "100%",
  "maxWidth": "100%",
  "flexDirection": "column",
  "borderBottomRightRadius": "1.5rem",
  "borderBottomLeftRadius": "1.5rem",
  "backgroundImage": "linear-gradient(149.71deg, #673EAE 1.59%, #44257D 90.79%)"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "default-navigation-bar___StyledDiv2",
  componentId: "sc-b7kgid-2"
})({
  "marginLeft": "auto",
  "marginRight": "auto"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "default-navigation-bar___StyledDiv3",
  componentId: "sc-b7kgid-3"
})({
  "maxWidth": "fit-content",
  "alignSelf": "flex-end"
});